import { render, staticRenderFns } from "./quiz-me.vue?vue&type=template&id=b23641d4&"
import script from "./quiz-me.vue?vue&type=script&lang=js&"
export * from "./quiz-me.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports